<template>
  <div>
    <section class="orders-header">
      <h1 class="text-center mb-8"><!-- {{ $t('navs.compte') }} --> {{ $t('welcome') }} {{ userName }}</h1>
    </section>
    <section class="profile-page">
      <v-overlay
        :opacity="0.5"
        :value="loading"
      >
        <v-progress-circular indeterminate size="64">
          {{ $t('loading') }}...
        </v-progress-circular>
      </v-overlay>
      <v-row>
        <v-col cols="12" lg="8" md="10">
          <!-- <h1 class="mb-8">{{ userName }}</h1> -->
          <v-container>
            <v-text-field solo v-model="form.name" :label="$t('auth.name')" height="30px"></v-text-field>
            <v-text-field solo v-model="form.email" :label="$t('auth.email')" height="30px"></v-text-field>
            <v-text-field solo v-model="form.phone" :label="$t('auth.phone')" height="30px"></v-text-field>
            <!-- <v-text-field solo v-model="form.city" :label="$t('auth.city')" height="30px"></v-text-field> -->
            <google-maps-address
              class="google-maps-field"
              v-model="form.address"
              v-on:updateaddress="updateAddress">
            </google-maps-address>
            <!-- <v-text-field solo v-model="form.address" :label="$t('auth.address')" height="30px"></v-text-field> -->
          </v-container>
          <div class="text-center">
            <v-btn class="primary my-5" @click="handleSaveUser">{{ $t("auth.save") }}</v-btn>
          </div>
        </v-col>
      </v-row>
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters} from "vuex";
import GoogleMapsAddress from '@/components/GoogleMapsAddress'

export default {
  name: 'Home',
  data() {
    return {
      form: {
        id: '',
        email: '',
        city: '',
        phone: '',
        address: '',
        name: ''
      }
    };
  },
  /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
  components:{
    GoogleMapsAddress,
  },

  computed: {
    ...mapGetters({
      loading: "auth/loading",
    }),
    userName() {
      let user = JSON.parse(window.localStorage.getItem("userDataGisabo"));
      return user.name; 
    }
  },
  methods: {
    ...mapActions({
      updateUser: "auth/updateUser"
    }),

    async handleSaveUser () {
      let user = await this.updateUser(this.form);
      if(user.status == 200) {
        window.location.reload()
      }
    },
    /**
     * @param {object} location
     * @returns {void}
     */
    updateAddress (location) {

      console.log(location)
        /*const _this = this
        this.details.postal_code = location.postal_code;
        this.details.coordinates = location.coorinates;
        if(location.postal_code.startsWith('J8') || location.postal_code.startsWith('J9')) {
            this.iAddress = this.details.address
            this.iPostal = location.postal_code
            this.iCoorinates = location.coorinates
        }else {
            this.details.address = this.cartAddress
            this.details.postal_code = this.cartPostal;
            Notification({
                title: _this.$t('important'),
                message: _this.$t('txt_warning'),
                type: 'error'
            });
        }*/
    },
  },
  mounted () {
    this.form = JSON.parse(window.localStorage.getItem('userDataGisabo'));
    console.log(this.loading)
  }
}
</script>
<style scoped>
.hero {
  background-size: cover;
}

.profile-page {
  padding: 3% 6%;
}

.v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

.profile-text-field {
  border-color: black;
  height: 40px;
  margin-bottom: 10px;
}

.orders-header {
    justify-content: center;
    align-content: center;
    padding: 100;
    border: 1px #eee solid;
    font-size: 30px;
}
</style>